module.exports = __webpack_public_path__ + "static/img/guiyuan.1e61d83e.png";